var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDatos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#707070",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86.332,
    height: 86.332,
    viewBox: "0 0 86.332 86.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 86.332,
    height: 86.332,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-191.326 -109.513)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.964,
    height: 2.641,
    transform: "translate(226.576 161.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.964,
    height: 2.641,
    transform: "translate(226.576 154.192)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "matrix(1, 0, 0, 1, 191.33, 109.51)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    className: "a",
    d: "M234.491,118.513a34.166,34.166,0,1,0,34.167,34.165,34.166,34.166,0,0,0-34.167-34.165Zm6.151,16.125,8.614,8.614h-8.614Zm7.452,36.469h-26.51a1.835,1.835,0,0,1-1.833-1.833V135.8a1.833,1.833,0,0,1,1.833-1.833h16.737v11.606h11.606v23.7a1.833,1.833,0,0,1-1.832,1.834Z",
    transform: "translate(-191.33 -109.51)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    className: "a",
    d: "M235.993,153.9l3.683,3.684,5.047-5.047-1.917-1.917-3.13,3.13-1.768-1.767Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    className: "a",
    d: "M239.676,161.39l-1.768-1.767-1.917,1.915,3.684,3.685,5.047-5.047-1.917-1.917Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDatos);
export default __webpack_public_path__ + "static/media/ico-datos.32a5d8e1529f68eb175b6470b49e9ef9.svg";
export { ForwardRef as ReactComponent };